import {ValidateVatNumberFormatPresenter} from "../../application/port/ValidateVatNumberFormatPresenter";
import {VatNumberFormatWebViewModel} from "../viewModel/VatNumberFormatWebViewModel";

export class ValidateVatNumberFormatWebPresenter implements ValidateVatNumberFormatPresenter {
    private viewModel: VatNumberFormatWebViewModel = {
        isValidVatNumber: false,
        errorMessage: null
    };

    notifyVatNumberFormatIsValid(): void {
        this.viewModel.isValidVatNumber = true;
        this.viewModel.errorMessage = null;
    }

    notifyVatNumberFormatIsInvalid(errorMessage: string): void {
        this.viewModel.isValidVatNumber = false;
        this.viewModel.errorMessage = errorMessage;
    }

    getViewModel(): VatNumberFormatWebViewModel {
        return this.viewModel;
    }
}
